/**
 * Routes Universal Links / custom URL opens into the React Router tree
 * when running inside the Pro Capacitor shell.
 */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { App } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
import {
  orderManagementScanPath,
  parseOrderIdFromScanPayload,
  spaPathFromDeepLink,
} from "../lib/orderQrDeepLink";

export function ProDeepLinkHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    let remove: (() => void) | undefined;

    void App.addListener("appUrlOpen", (event) => {
      const orderId = parseOrderIdFromScanPayload(event.url);
      if (orderId) {
        navigate(orderManagementScanPath(orderId));
        return;
      }
      const spaPath = spaPathFromDeepLink(event.url);
      if (spaPath?.startsWith("/pro/")) {
        navigate(spaPath);
      }
    }).then((handle) => {
      remove = () => void handle.remove();
    });

    return () => {
      remove?.();
    };
  }, [navigate]);

  return null;
}
